import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TooltipActions from "actions/tooltip-actions";

// a HOC to allow for you to auto-pop the tooltip on load
// expects component will have the following propTypes:
//  - onToggleTooltip: PropTypes.func,
//  - showTooltipOnLoad: PropTypes.bool,

export function withShowTooltipOnLoad(locationKey) {
  return function (WrappedComponent) {
    const componentKey = WrappedComponent.displayName || WrappedComponent.name;

    class C extends Component {
      static propTypes = {
        onToolTipDisplayed: PropTypes.func,
        onToolTipInitialization: PropTypes.func,
        showTooltipOnLoad: PropTypes.bool,
      };

      componentDidMount() {
        const { onToolTipInitialization, showTooltipOnLoad } = this.props;

        if (showTooltipOnLoad === false) return;

        onToolTipInitialization(componentKey);
      }

      handleToggle = isVisible => {
        const { onToolTipDisplayed } = this.props;

        if (isVisible !== false) return;

        onToolTipDisplayed(componentKey, prev => ({
          [locationKey]: { ...prev[locationKey], shouldShowOnLoad: false },
        }));
      };

      render() {
        return (
          <WrappedComponent {...this.props} onToggleTooltip={this.handleToggle} tooltipLocationKey={locationKey} />
        );
      }
    }

    // connecting this component is required to check whether a member is in the
    // appropriate state, which initially means "is Active, regardless of state"
    function mapStateToProps(state, ownProps) {
      const { showTooltipOnLoad: providedValue = null } = ownProps;

      if (providedValue !== null) return {};

      const {
        tooltipSettings: { [componentKey]: { loaded, [locationKey]: { shouldShowOnLoad = loaded } = {} } = {} } = {},
      } = state;

      return { showTooltipOnLoad: shouldShowOnLoad };
    }

    const mapDispatchToProps = {
      onToolTipDisplayed: TooltipActions.updateTooltipSettings,
      onToolTipInitialization: TooltipActions.initializeTooltipSettings,
    };

    const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(C);

    ConnectedComponent.displayName = `withShowTooltipOnLoad(${componentKey})`;
    return ConnectedComponent;
  };
}
